const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://pulsodrive.dvgeo.app' : 'http://192.168.100.106:3029',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://pulsodrive.dvgeo.app' : 'http://192.168.100.106:3029',
    api: 'api/',
    apiSocket: 'pulsodrive::1.2',
    nameDir: 'pulsodrive',
    package: 'ec.pulsodrive.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyAx8aNohaI7UXVrqfcv6d55LTJoqP5on1w',
    appName: 'PulsoDrive',
    provider: '',
    colorPrimary: '#ec8321',
    colorDark: '#ec8321',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'ec.pulsodrive.passenger',
    playStoreDriverId: 'ec.pulsodrive.driver',
    appStorePassengerId: '6761638140',
    appStoreDriverId: '6761638334',
};
export default config;
